import React from 'react';

export const PhoneStar = ({ width = 16, height = 16, className = '' }) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_36937_593040)">
      <path
        d="M7.72267 12.8167C6.08871 11.9663 4.70282 10.7073 3.69995 9.16218C2.69708 7.6171 2.11142 5.83866 2 4.00002C2 3.6464 2.14048 3.30726 2.39052 3.05721C2.64057 2.80716 2.97971 2.66669 3.33333 2.66669H6L7.33333 6.00002L5.66667 7.00002C6.38064 8.44771 7.55231 9.61938 9 10.3334L10 8.66669L10.4333 8.84002"
        stroke="currentColor"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6668 15C12.8037 14.4342 13.0939 13.917 13.5055 13.5054C13.9172 13.0937 14.4343 12.8035 15.0002 12.6666C14.4343 12.5298 13.9172 12.2396 13.5055 11.8279C13.0939 11.4163 12.8037 10.8991 12.6668 10.3333C12.53 10.8991 12.2397 11.4163 11.8281 11.8279C11.4165 12.2396 10.8993 12.5298 10.3335 12.6666C10.8993 12.8035 11.4165 13.0937 11.8281 13.5054C12.2397 13.917 12.53 14.4342 12.6668 15Z"
        stroke="currentColor"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_36937_593040">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
